module.exports = __webpack_public_path__ + "img/cccd-holder.eed4d901.png";